import { defineStore } from 'pinia'
import { getDatabaseDisplayNames } from '@/Services/Ressources/API/ForretningService'

// One shared "which database am I looking at" value for the whole analytics area.
// Settings, Business and Operations all read/write this so a selection made on one
// page follows the user to the others (and is no longer reset to the first database
// every time a page mounts). The choice is persisted so a page refresh keeps it too.
const STORAGE_KEY = 'eap.selectedDatabase'

export const useDatabaseStore = defineStore('database', {
  state: () => ({
    databases: [],
    selected: localStorage.getItem(STORAGE_KEY) || '',
    loaded: false,
    loading: null
  }),
  getters: {
    // Single-database users never see a selector and never send a databaseDisplayName,
    // so their behaviour is unchanged.
    hasMultiple: (state) => state.databases.length > 1
  },
  actions: {
    // Fetches the accessible databases once. Concurrent callers share the same
    // in-flight request so we never hit the endpoint twice on a fresh load.
    async init() {
      if (this.loaded) return
      if (this.loading) return this.loading

      this.loading = (async () => {
        try {
          const names = await getDatabaseDisplayNames()
          this.databases = Array.isArray(names) ? names : []
          // Honour a persisted selection only if the user still has access to it;
          // otherwise fall back to the first database.
          if (!this.databases.includes(this.selected)) {
            this.setSelected(this.databases[0] || '')
          }
          this.loaded = true
        } finally {
          this.loading = null
        }
      })()

      return this.loading
    },
    setSelected(name) {
      this.selected = name || ''
      if (this.selected) {
        localStorage.setItem(STORAGE_KEY, this.selected)
      } else {
        localStorage.removeItem(STORAGE_KEY)
      }
    }
  }
})
